module.exports = __webpack_public_path__ + "24bc71e02940cf5ee8c121844da30cf4.png";